export const roleOptions = [
  { text: "Administrator", value: "Admin" },
  { text: "Moderator", value: "Moderator" },
  { text: "Member", value: "Member" },
];
